module.exports = __webpack_public_path__ + "static/media/phoneIconError.8023eafc.svg";